import Dialog from '../../components/Dialog'
import usePopup from './usePopup'

export default function PopupComponent() {
    const { children, ...props } = usePopup()

    return <Dialog {...props}>{children}</Dialog>
}
